@if (isAllowedToBeSeen && show && displayValue) {
  <td style="width: fit-content; display: inline;  margin-right: 0%; text-align: end;"
    >
    <!-- 'Normal' line, name and value  -->
    <span style="width: fit-content;">&nbsp;&nbsp;{{ displayValue }}</span>
  </td>
}
